import Joi from 'joi';
import type { IStaff } from './staff';
import type { AllExcept } from '../helpers';
import { objectSchemaOf } from '../helpers';

export type ICreateStaffParams = AllExcept<
  IStaff,
  'createdOn' | 'lastUpdatedOn' | 'staffId' | 'companyName'
> & { visitabilityRank?: number };

export const createStaffParamsSchema = objectSchemaOf<ICreateStaffParams>({
  organisationId: Joi.string().required(),
  firstName: Joi.string().required(),
  lastName: Joi.string().required(),
  email: Joi.string().email().required(),
  primaryPhone: Joi.string().optional(),
  slackChannelId: Joi.string().optional(),
  avatar: Joi.string().optional(),
  isAdministrator: Joi.boolean().optional(),
  visitabilityRank: Joi.number().optional(),
  position: Joi.string().optional(),
  isRemote: Joi.boolean().optional(),
  hasLeft: Joi.boolean().optional(),
  nicknames: Joi.array().items(Joi.string()).optional(),
  companyId: Joi.string().optional(),
  isCompanyAdministrator: Joi.boolean().optional(),
});

export interface IDeleteStaffParams {
  staffId: string;
}

export const deleteStaffParamsSchema = objectSchemaOf<IDeleteStaffParams>({
  staffId: Joi.string().required(),
});

export interface IGetStaffParams {
  staffId: string;
}

export const getStaffParamsSchema = objectSchemaOf<IGetStaffParams>({
  staffId: Joi.string().required(),
});

export interface IListStaffParams {
  organisationId: string;
}

export const listStaffParamsSchema = objectSchemaOf<IListStaffParams>({
  organisationId: Joi.string().required(),
});

export type IUpdateStaffParams = Partial<ICreateStaffParams> & {
  staffId: string;
};

export const updateStaffParamsSchema = objectSchemaOf<IUpdateStaffParams>({
  staffId: Joi.string().required(),
  organisationId: Joi.string().optional(),
  firstName: Joi.string().optional(),
  lastName: Joi.string().optional(),
  email: Joi.string().optional(),
  primaryPhone: Joi.string().optional(),
  slackChannelId: Joi.string().optional(),
  avatar: Joi.string().optional(),
  isAdministrator: Joi.boolean().optional(),
  visitabilityRank: Joi.number().optional(),
  position: Joi.string().optional(),
  hasLeft: Joi.boolean().optional(),
  isRemote: Joi.boolean().optional(),
  nicknames: Joi.array().items(Joi.string()).optional(),
  companyId: Joi.string().optional(),
  isCompanyAdministrator: Joi.boolean().optional(),
});
